define('Store.Facets.ItemListSortSelector.View', [
	'Backbone',
	'Facets.ItemListSortSelector.View',
	'Profile.Model',
	'SC.Configuration',
	'underscore'
], function StoreFacetsItemListSortSelectorView(
	Backbone,
	FacetsItemListSortSelectorView,
	ProfileModel,
	Configuration,
	_
) {
	'use strict';

	_.extend(FacetsItemListSortSelectorView.prototype, {
		getContext: _.wrap(FacetsItemListSortSelectorView.prototype.getContext, function getContext(fn) {
			var profile = ProfileModel.getInstance();
			var store = profile.get('store');
			var storeId = store && store.get && store.get('internalid');
			var pricelevel = profile.get('priceLevel');
			var defaultPricelevel = SC.ENVIRONMENT.siteSettings.defaultpricelevel;
			var priceField = store && store.get && store.get('priceField');
			var changeField = pricelevel !== defaultPricelevel && priceField && String(priceField).toLowerCase();
			var isSearchSpring = this.options.translator && this.options.translator.isSearchSpring;
			var priceLevelMapping = Configuration.get('searchspring.priceLevelMapping') || [];
			var priceStore = changeField && priceLevelMapping && _.findWhere(priceLevelMapping, { netsuiteid: pricelevel });
			var options = this.options.options;

			if (!_.isArray(options)) {
				return fn.apply(this, _.toArray(arguments).slice(1));
			}

			this.options.options = _.filter(options, function filterSortOptions(sortOption) {
				if (!sortOption || !sortOption.id) {
					return false;
				}
				if (changeField && sortOption.id.indexOf && sortOption.id.indexOf(changeField) === 0) {
					if (isSearchSpring && priceStore && priceStore.searchspringid) {
						sortOption.id = sortOption.id.replace(changeField, priceStore.searchspringid);
					} else if (!isSearchSpring) {
						sortOption.id = sortOption.id.replace(changeField, 'onlinecustomerprice');
					}
				}
				return !sortOption.storeId || (storeId && sortOption.storeId + '' === storeId + '');
			});
			return fn.apply(this, _.toArray(arguments).slice(1));
		})
	});
});
